//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalConfirm',
  props: {
    message: {
      type: String,
      required: true,
      default: null
    },
    cancelButtonText: {
      type: String,
      required: false,
      default: 'No'
    },
    confirmButtonText: {
      type: String,
      required: false,
      default: 'Yes'
    }
  },
  data: function data() {
    return {
      isLoading: false
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      this.isLoading = true;
      this.$emit('submitItem');
    },
    onCancel: function onCancel() {
      this.$emit('closeConfirmModal');
    }
  }
};